import {
  createToastFn
} from "./chunk-RANSABEB.mjs";

// src/use-toast.tsx
import { useChakra } from "@chakra-ui/system";
import { useMemo } from "react";
function useToast(defaultOptions) {
  const { theme } = useChakra();
  return useMemo(
    () => createToastFn(theme.direction, defaultOptions),
    [defaultOptions, theme.direction]
  );
}
var use_toast_default = useToast;

export {
  useToast,
  use_toast_default
};
